module.exports = ":host {\n  display: block;\n}\n\n.content-wrapper {\n     position: relative;\n}\n"